import { Injectable } from '@angular/core';
import { OkObject } from '@libs/types/src/common/object-type/ok.object';
import { WorkRecorderCreateInput } from '@libs/types/src/services/input-type/work/work-recorder.create-input';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class WorkRecorderGqlService extends GqlServiceV2 {

    public createWorkRecorder(input: WorkRecorderCreateInput): Promise<OkObject> {
        return this.mutate<OkObject>(`
            mutation($input: WorkRecorderCreateInput!) {
                workRecorder {
                    create(input: $input) {
                        ok
                    }
                }
            }
        `, { input });
    }

}
